import { forwardRef } from 'react'
import NextLink from 'next/link'

const BhNextLink = forwardRef(function BhNextLinkComponent({ children, _as, ...props }, ref) {
	// NOTE: we're using `_as` as a prop instead of `as` because `as` is used by `emotion/styled` and it throws a warning
	return (
		// https://nextjs.org/docs/13/app/building-your-application/routing/linking-and-navigating#1-prefetching
		// prefetch={false} // disable prefetching by default and leave it on in view
		<NextLink ref={ref} as={_as} prefetch={false} {...props}>
			{children}
		</NextLink>
	)
})

BhNextLink.propTypes = {
	...NextLink.propTypes,
}

BhNextLink.defaultProps = {
	...NextLink.defaultProps,
}

export default BhNextLink
